import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P29-E1',
    audio: 'img/FriendsPlus/Page29/Audio/audio-e3-p28.mp3',
    video: 'Videos/e3.p28.mp4',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [{ url: 'img/FriendsPlus/Page29/E1/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page29/E1/4.jpg' }],
      [
        { url: 'img/FriendsPlus/Page29/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page29/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page29/Audio/hinh1-e3-p28.mp3' },
        { url: 'img/FriendsPlus/Page29/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page29/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page29/Audio/hinh2-e3-p28.mp3' },
        { url: 'img/FriendsPlus/Page29/E1/9.jpg' },
      ],
      [{ url: 'img/FriendsPlus/Page29/E1/10.jpg' }],
      [
        { url: 'img/FriendsPlus/Page29/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page29/E1/12.jpg', audioUrl: 'img/FriendsPlus/Page29/Audio/hinh3-e3-p28.mp3' },
        { url: 'img/FriendsPlus/Page29/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page29/E1/14.jpg', audioUrl: 'img/FriendsPlus/Page29/Audio/hinh4-e3-p28.mp3' },
        { url: 'img/FriendsPlus/Page29/E1/15.jpg' },
      ],
      [{ url: 'img/FriendsPlus/Page29/E1/16.jpg' }],
      [
        { url: 'img/FriendsPlus/Page29/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page29/E1/18.jpg', audioUrl: 'img/FriendsPlus/Page29/Audio/hinh5-e3-p28.mp3' },
        { url: 'img/FriendsPlus/Page29/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page29/E1/20.jpg', audioUrl: 'img/FriendsPlus/Page29/Audio/hinh6-e3-p28.mp3' },
        { url: 'img/FriendsPlus/Page29/E1/21.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: "Unit 4",
    id: "SB3-U4-P29-E2",
    audio: "img/FriendsPlus/Page29/Audio/audio-e2-p29.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page29/E2/1.jpg" },
        { url: "img/FriendsPlus/Page29/E2/2.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/tieude-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page29/E2/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page29/E2/5.jpg" },
        { url: "img/FriendsPlus/Page29/E2/6.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh1-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/7.jpg" },
        { url: "img/FriendsPlus/Page29/E2/8.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh2-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/9.jpg" },
        { url: "img/FriendsPlus/Page29/E2/10.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh3-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/11.jpg" },
        { url: "img/FriendsPlus/Page29/E2/12.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh4-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/13.jpg" }
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page29/E2/14.jpg" },
        { url: "img/FriendsPlus/Page29/E2/15.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh1-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/16.jpg" },
        { url: "img/FriendsPlus/Page29/E2/17.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh2-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/18.jpg" },
        { url: "img/FriendsPlus/Page29/E2/19.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh3-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/20.jpg" },
        { url: "img/FriendsPlus/Page29/E2/21.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh4-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/22.jpg" }
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page29/E2/23.jpg" },
        { url: "img/FriendsPlus/Page29/E2/24.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh1-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/25.jpg" },
        { url: "img/FriendsPlus/Page29/E2/26.jpg", audioUrl: "img/FriendsPlus/Page29/Audio/hinh2-e2-p29.mp3" },
        { url: "img/FriendsPlus/Page29/E2/27.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page29/E2/28.jpg" }],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P29-E3',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page29/E3/1.jpg' }]],
  },
  4: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P29-E4',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page29/E4/Key/answerKey.png',
    isAllowSubmit: false,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page29/E4/1.jpg' }],
      [
        // Column1
        { url: 'img/FriendsPlus/Page29/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page29/E4/3.jpg', input: true, answer: "their" },
        { url: 'img/FriendsPlus/Page29/E4/4.jpg' },
      ],
      [{ url: 'img/FriendsPlus/Page29/E4/5.jpg' }],
      [
        // Column3
        { url: 'img/FriendsPlus/Page29/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page29/E4/7.jpg', input: true, answer: "our" },
        { url: 'img/FriendsPlus/Page29/E4/8.jpg' },
        { url: 'img/FriendsPlus/Page29/E4/9.jpg', input: true, answer: "their" },
        { url: 'img/FriendsPlus/Page29/E4/10.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page29/E4/11.jpg' },
      ],
    ]
  },
  5: { // Exercise num
    unit: 'Unit 4',
    id: 'SB3-U4-P29-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page29/E5/1.jpg' }]],
  },
}

export default json;